<ng-container *ngIf="isShowProductList">
  <div class="empty" *ngIf="!damElements?.length" style="max-width: 900px">
    {{ translations.noResults }}
  </div>

  <div class="plates-grid">
    <ng-container *ngFor="let damItem of (damElements | paginate: paginationConfig)">
      <div (click)="elementClickEvent(damItem);" class="item" [ngClass]="{
        'selected': damItem?.selected
      }">
        <div class="actions-panel" *ngIf="write">
          <div class="actions-panel-top" (click)="$event.stopPropagation()">
            <ng-container *ngTemplateOutlet="ActionButtons; context: {row:damItem, withText: false}"/>
          </div>
          <div class="actions-panel-bottom" *ngIf="damItem.tagsForPreview?.length>0">
            <span class="badge" *ngFor="let tag of damItem.tagsForPreview?.slice(0,4)">{{ tag }}</span> <span class="badge" *ngIf="damItem.tagsForPreview?.length > 4">+{{ damItem.tagsForPreview?.length - 4 }}</span>
          </div>
        </div>

        <app-secured-image [lazy]="true" [src]="damService.getImagePath(damItem, share)" style="height: 70%; width: 100%;"/>

        <span class="item-title">
          {{ damItem.header }}
        </span>

        <div class="item-actions">
          <span>
            <nb-checkbox (click)="$event.stopPropagation()" (checkedChange)="elementSelectHandler(damItem, $event);" [checked]="selected$.value.has(damItem.id)" *ngIf="write"/>
          </span>

          <div class="item-actions-right">
            <nb-icon *ngIf="damItem.enabled" nbTooltip="Aктивен" icon="checkmark-circle-2-outline" status="success"/>
            <nb-icon *ngIf="!damItem.enabled" nbTooltip="Не активен" icon="checkmark-circle-2-outline" status="danger"/>
            <nb-icon *ngIf="damItem.approved" nbTooltip="Подтвержден" icon="shield-outline" status="success"/>
            <nb-icon *ngIf="!damItem.approved" nbTooltip="Не подтвержден" icon="shield-outline" status="danger"/>
            <nb-icon *ngIf="damItem.deleted" nbTooltip="Удален" icon="file-remove-outline" status="danger"/>

            <div class="item-actions-files" nbTooltip="Количество версий" *ngIf="damItem.countVersion > 1">
              <nb-icon icon="attach-outline"/>
              {{ damItem.countVersion }}
            </div>
          </div>
        </div>
      </div>
    </ng-container>

  </div>

  <br>
  <pagination [id]="paginationConfig.id" [config]="configuration" [pagination]="pagination" (update)="onPagination($event)"/>
</ng-container>

<ng-container *ngIf="!isShowProductList">
  <ngx-table #table [columns]="columns" [configuration]="configuration" [data]="damElements" [pagination]="pagination" (event)="eventEmitted($event)"/>
</ng-container>

<ng-template #statusTpl let-row>
  <div class="statuses">
    <nb-icon *ngIf="row.enabled" nbTooltip="Aктивен" icon="checkmark-circle-2-outline" status="success"/>
    <nb-icon *ngIf="!row.enabled" nbTooltip="Не активен" icon="checkmark-circle-2-outline" status="danger"/>
    <nb-icon *ngIf="row.approved" nbTooltip="Подтвержден" icon="shield-outline" status="success"/>
    <nb-icon *ngIf="!row.approved" nbTooltip="Не подтвержден" icon="shield-outline" status="danger"/>
    <nb-icon *ngIf="row.deleted" nbTooltip="Удален" icon="file-remove-outline" status="danger"/>
  </div>
</ng-template>

<ng-template #imageTpl let-damItem>
  <div (click)="elementClickEvent(damItem);" class="item">
    <app-secured-image [lazy]="true" [src]="damService.getImagePath(damItem, share)" style="height: 70%; width: 100%;"/>
  </div>
</ng-template>

<ng-template #headerTpl let-damItem>
  <div (click)="elementClickEvent(damItem);" class="item">
    {{ damItem.header }}<br> <small>{{ damItem.createdAt | date: 'dd.MM.yyyy mm:hh' }}</small>
  </div>
</ng-template>

<ng-template #countVersionTpl let-row>
  <div class="badge">
    <nb-icon icon="attach-outline"/>
    {{ row.countVersion }}
  </div>
</ng-template>

<ng-template #tagsTpl let-row>
  <div class="badge" *ngFor="let tag of row.tagsForPreview?.slice(0,4)">{{ tag }}</div>
  <div class="badge" *ngIf="row.tagsForPreview?.length > 4">+{{ row.tagsForPreview?.length - 4 }}</div>
</ng-template>

<ng-template #ownerTpl let-row>
  <div>{{ row.managerName }}</div>
  <div>{{ row.managerEmail }}</div>
</ng-template>

<ng-template #actionsTpl let-row>
  <button nbButton status="control" [matMenuTriggerFor]="menu" *ngIf="write">
    <nb-icon icon="more-vertical-outline"/>
  </button>
  <mat-menu #menu="matMenu">
    <ng-container *ngTemplateOutlet="ActionButtons; context: {row:row, withText: true}"/>
  </mat-menu>
</ng-template>


<ng-template #ActionButtons let-row="row" let-withText="withText">
  @if (withText) {
    <a mat-menu-item (click)="damService.downloadDamItem(row)">
      <nb-icon icon="download-outline"/>
      Скачать</a><a mat-menu-item target="_blank" href="/cabinet/dam/item/edit/{{row.id}}">
      <nb-icon icon="edit-outline"/>
      Редактировать</a><a mat-menu-item (click)="elementChangeCatalogHandler(row)">
      <nb-icon icon="repeat-outline"/>
      Переместить</a><a mat-menu-item (click)="elementShareHandler(row)">
      <nb-icon icon="share-outline"/>
      Поделиться </a><a mat-menu-item (click)="onElementDelete(row)">
      <nb-icon icon="trash-outline"/>
      Удалить </a>
  } @else {
    <a nbTooltip="Скачать" (click)="damService.downloadDamItem(row)">
      <nb-icon icon="download-outline"/>
    </a><a nbTooltip="Редактировать" target="_blank" href="/cabinet/dam/item/edit/{{row.id}}">
      <nb-icon icon="edit-outline"/>
    </a><a nbTooltip="Переместить" (click)="elementChangeCatalogHandler(row)">
      <nb-icon icon="repeat-outline"/>
    </a><a nbTooltip="Поделиться" (click)="elementShareHandler(row)">
      <nb-icon icon="share-outline"/>
    </a><a nbTooltip="Удалить" (click)="onElementDelete(row)">
      <nb-icon icon="trash-outline"/>
    </a>
  }
</ng-template>
